import { hasContent, questionVisible, fmtDate } from "@/villa142/config";
import { ContributionDisplay } from "@/villa142/QuestionCard";

export default function Review({ def, entriesMap, people, onEdit, onSubmit, submitting, error, submitted, submittedAt, updatedAfterShareAt, changedSince }) {
  return (
    <section className="v142-review" data-testid="v142-review-screen">
      <p className="v142-eyebrow">{submitted ? "Shared with Ōraṇi" : "Before you share"}</p>
      <h1 className="v142-display">Your reflections, gathered</h1>
      <p className="v142-copy v142-review-lede">
        Nothing here is required. Anything left open is simply part of the conversation to come.
      </p>
      {submitted && (
        <p className="v142-shared-note" data-testid="v142-shared-note">
          Shared with Ōraṇi · {fmtDate(submittedAt)}
        </p>
      )}

      {(def?.chapters || []).map((ch) => {
        const visible = ch.questions.filter((q) => questionVisible(q, entriesMap));
        const answered = visible.filter((q) => people.order.some((c) => hasContent(entriesMap[q.id]?.[c])));
        const open = visible.filter((q) => !people.order.some((c) => hasContent(entriesMap[q.id]?.[c])));
        if (!visible.length) return null;
        return (
          <div className="v142-review-chapter" key={ch.id}>
            <h2 className="v142-review-chtitle">{ch.title}</h2>
            {answered.map((q) => (
              <div className="v142-review-row" key={q.id}>
                <div className="v142-review-body">
                  <p className="v142-review-q">{q.label}</p>
                  {people.order.filter((c) => hasContent(entriesMap[q.id]?.[c])).map((c) => (
                    <ContributionDisplay
                      key={c}
                      question={q}
                      entry={entriesMap[q.id][c]}
                      people={people}
                      onEdit={() => onEdit(q.id, c)}
                    />
                  ))}
                </div>
              </div>
            ))}
            {answered.length === 0 && open.length > 0 && (
              <p className="v142-review-quiet">Nothing added in this chapter yet — it is waiting whenever you are.</p>
            )}
            {open.length > 0 && (
              <details className="v142-open-details" data-testid={`v142-open-${ch.id}`}>
                <summary className="v142-open-summary">Open reflections ({open.length})</summary>
                <div className="v142-open-list">
                  {open.map((q) => (
                    <div className="v142-open-row" key={q.id}>
                      <span className="v142-open-q">{q.label}</span>
                      <button type="button" className="v142-link" data-testid={`v142-open-add-${q.id}`} onClick={() => onEdit(q.id)}>
                        Add
                      </button>
                    </div>
                  ))}
                </div>
              </details>
            )}
          </div>
        );
      })}

      <div className="v142-review-submit">
        {error && <p className="v142-error" role="alert">{error}</p>}
        {!submitted && (
          <>
            <p className="v142-copy v142-share-note" data-testid="v142-before-share-note">
              Your reflections are saved as you go. Share when you feel they are ready for us to consider together.
            </p>
            <button className="v142-btn v142-btn-solid" data-testid="v142-submit-btn" disabled={submitting} aria-busy={submitting} onClick={onSubmit}>
              {submitting ? "Sharing reflections…" : "Share reflections with Ōraṇi"}
            </button>
          </>
        )}
        {submitted && (
          <p className="v142-copy" data-testid="v142-shared-reassurance">
            Everything here is with the studio. If anything new arises, simply add it — we will follow the thread.
          </p>
        )}
        {submitted && changedSince && (
          <>
            <p className="v142-copy v142-share-note" data-testid="v142-changed-since-note">You have added to your reflections since they were shared.</p>
            <button className="v142-btn v142-btn-solid" data-testid="v142-save-changes-btn" disabled={submitting} aria-busy={submitting} onClick={onSubmit}>
              {submitting ? "Saving…" : "Save changes for Ōraṇi"}
            </button>
          </>
        )}
        {submitted && !changedSince && updatedAfterShareAt && (
          <p className="v142-shared-note" data-testid="v142-saved-after-share-note">Changes saved for Ōraṇi · {fmtDate(updatedAfterShareAt)}</p>
        )}
      </div>
    </section>
  );
}
